import { useNavigate, useParams, useLocation } from "react-router-dom";
import React, { useState, useCallback, useEffect, useRef, useContext } from "react";
import SignatureCanvas from 'react-signature-canvas'


import { UserContext } from "./UserContext.js";


import helpers from "./helpers.js";
import styles from './CharcodeScreen.module.css'; //styles

import Button from "./components/Button.js";
import QRScanner from "./components/QRCodeScanner.js";
import TextInput from "./components/TextInput.js";
import Checkbox from "./components/Checkbox.js";

import Selector from "./components/Selector.js";
import DateSelector from "./components/DateSelector.js";
import Charpoints from "./components/CharpointsBanner.js";





import greenCircles from "./assets/images/greenCirclesCorner.png";
import bbbLogo from "./assets/images/bbbLogo.png";
// import baggingImage from "./assets/images/baggingImage.png";
// import pickupImage from "./assets/images/pickupImage.png";
// import deliveryImage from "./assets/images/deliveryImage.png";
// import applicationImage from "./assets/images/applicationImage.png";

import successImage from "./assets/images/check.png";
import pickedUpImage from "./assets/images/bagPickedUp.png";
import icon404 from "./assets/images/icon404.png";
import dots from "./assets/images/patternDots.png";
import ebc from "./assets/images/EBC.png";
import iconCalendarAlt from "./assets/images/iconCalendarAlt.png";
import iconBalanceScale from "./assets/images/iconBalanceScale.png";
import iconIndustry from "./assets/images/iconIndustry.png";
import iconShoppingBag from "./assets/images/iconShoppingBag.png";
import iconStorage from "./assets/images/iconStorage.png";
import iconTruck from "./assets/images/iconTruck.png";
import iconWater from "./assets/images/iconWater.png";
import iconHeat from "./assets/images/iconHeat.png";
import iconUserCircle from "./assets/images/iconUserCircle.png";
import chromeLocation1 from "./assets/images/chromeLocation1.png";
import chromeLocation2 from "./assets/images/chromeLocation2.png";
import chromeLocation3 from "./assets/images/chromeLocation3.png";








const CharcodeScreen = (props) => {
  document.title = "Charcode Form";

  const [location, setLocation] = useState({ lat: null, long: null });
  const {user, setUser} = useContext(UserContext);
    const navigate = useNavigate();

  const [farmer, setFarmer] = useState("12");
  const [appliedToZone, setAppliedToZone] = useState(false);
  const [mainBag, setMainBag] = useState({});
  const [order, setOrder] = useState({});
  const [bagsFromOrder, setBagsFromOrder] = useState([]);
  const [ebcBatchUrl, setEbcBatchUrl] = useState([]);
  const [showEbcCert, setShowEbcCert] = useState(false);

  const [retry, setRetry] = useState(false);
  const [charcodesCollapsed, setCharcodesCollapsed] = useState(false);
  // const [requestBody, setRequestBody] = useState({})


  const d = new Date();

  //Bagging
  const [weight, setWeight] = useState(0);
  const [moistureContent, setMoistureContent] = useState("");
  const [internalTemperature, setInternalTemperature] = useState("");

  const [site, setSite] = useState("");

  //Pickup
  const [orders, setOrders] = useState([]);
  const [ordersContent, setOrdersContent] = useState([]); //Used to view previously "picked up" bags already assigned to an order

  // const [orderNumberBags, setOrderNumberBags] = useState(null)
  const [selectedOrder, setSelectedOrder] = useState("")

  //Delivery
  const [applicationDate, setApplicationDate] = useState(d.getFullYear() + "-" + (d.getMonth() + 1).toString().padStart(2, '0') + "-" + d.getDate().toString().padStart(2, '0'));
  const [endUse, setEndUse] = useState("");
  const [machinery, setMachinery] = useState("");
  const [zoneId, setZoneId] = useState("");
  const [zones, setZones] = useState([]); // Used to store zones for the application screen
  const [baggingDate, setBaggingDate] = useState(d.getFullYear() + "-" + (d.getMonth() + 1).toString().padStart(2, '0') + "-" + d.getDate().toString().padStart(2, '0'));
  const [screen, setScreen] = useState("loading"); //bagging, pickup, delivery, application
  const [successScreen, setSuccessScreen] = useState("success"); // fullyLoaded, bagAdded Determines what the success screen should look like

  const [displayScanner, setDisplayScanner] = useState(false);
  const [displaySignatureOverlay, setDisplaySignatureOverlay] = useState(false);
  const [acceptedTC, setAcceptedTC] = useState(false);
  const [errorPopup, setErrorPopup] = useState(null); // { title, body, details[] }
  const [isStorage, setIsStorage] = useState(false);

  const containerRef = useRef(null);
  const [isProcessing, setIsProcessing] = useState(false);

  // Bag-added success tracking
  const [lastAddedCharcode, setLastAddedCharcode] = useState(null);
  const [lastAddedOrderDisplayId, setLastAddedOrderDisplayId] = useState(null);

const { charcodeId: rawCharcodeId } = useParams();
const redirected = useRef(false);
const [charcodeId, setCharcodeId] = useState(rawCharcodeId); // normalized value
const { state: routerState } = useLocation();
const prevScanComplete = useRef(null);

useEffect(() => {
  if (!redirected.current) {
    const match = /^CHA-(\d{1,6})$/.exec(rawCharcodeId);
    if (match) {
      const padded = match[1].padStart(6, "0");
      const corrected = `CHA-${padded}`;
      if (rawCharcodeId !== corrected) {
        redirected.current = true;
        setCharcodeId(corrected); // update state
        navigate(`/charcode/${corrected}`, { replace: true });
      }
    }
  }
}, [rawCharcodeId, navigate]);

const [scanResults, setScanResults] = useState([]);
  const [scanResults2, setScanResults2] = useState(["CHA-000001", "CHA-000002", "CHA-000003", "CHA-000004", "CHA-000005", "CHA-000006", "CHA-000007", "CHA-000008", "CHA-000009", "CHA-000010", "CHA-000011", "CHA-000012", "CHA-000013", "CHA-000014", "CHA-000015", "CHA-000016", "CHA-000017", "CHA-000018", "CHA-000019", "CHA-000020"])

  const [totalBagsExpected, setTotalBagsExpected] = useState("?")
  const sigCanvas = useRef(null);

  // Scroll container to top on every screen change
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
  }, [screen]);

  useEffect(() => {
  if (charcodeId) {
    setScanResults([charcodeId.slice(-10)]);
  }
}, [charcodeId]);

useEffect(() => {
  const sc = routerState?.scanComplete;
  if (sc && sc !== prevScanComplete.current) {
    prevScanComplete.current = sc;
    setRetry(r => !r);
  }
}, [routerState?.scanComplete]);


  const clearCanvas = () => {
    sigCanvas.current.clear();
  };

  // useEffect(() => {
  //   console.log(scanResults)
  //   const uniqueSet = new Set(scanResults);
  //   // Convert the Set back to an array
  //   const uniqueArr = [...uniqueSet];
  //   console.log(uniqueArr);
  // },[scanResults])

  const handleSetWeight = (value) => {
    if (!isNaN(value)) {
      setWeight(value);
    }
  };

  const handleSetMoistureContent = (value) => {
    if (!isNaN(value)) {
      setMoistureContent(value);
    }
  };

  const handleSetInternalTemperature = (value) => {
    if (!isNaN(value)) {
      setInternalTemperature(value);
    }
  };

  const isValidNumberFormat = (value) => /^\d+(\.\d+)?$/.test(String(value).trim());

  // Shows a BBB popup and returns a promise: resolves true (Proceed) or false (dismissed/cancelled).
  // Hard errors show only an OK button and always resolve false.
  // Soft warnings show Proceed/Cancel and resolve true/false based on the user's choice.
  const awaitPopup = (issue) => new Promise((resolve) => {
    const isHard = issue.type === 'hard';
    setErrorPopup({
      title: issue.title,
      body: issue.body,
      details: issue.details || [],
      ...(!isHard && {
        confirmLabel: 'Proceed',
        cancelLabel: 'Cancel',
        closeOnConfirm: false,
        onConfirm: () => {
          setErrorPopup(null);
          resolve(true);
        },
      }),
      onDismiss: () => resolve(false),
    });
  });

   const selectOrder = (order) => {
    console.log(order)
    orders.forEach((ord) => {
      if(ord._id === order){
        setTotalBagsExpected(ord.products[0].amount + ord.products[1].amount)
      }
    })
    setSelectedOrder(order)   
  }
    
  const checkIfOrderFull = () => {
    console.log(totalBagsExpected)
    console.log(ordersContent)
    console.log(scanResults.length)

    // Filter ordersContent to only count bags from the currently selected order
    const bagsInSelectedOrder = ordersContent.filter(item => item.order_id === selectedOrder);
    console.log("Bags in selected order:", bagsInSelectedOrder.length)

    if((scanResults.length + bagsInSelectedOrder.length) >= totalBagsExpected){
      console.log("TRUE")
      return true;
    } else {
      console.log("FALSE")
      return false;
    }
  }

  const getLocation = () => {
    if (location.lat !== null) {
      return Promise.resolve({ lat: location.lat, long: location.long });
    }
    // In local development, skip the browser location prompt and use London coordinates
    if (process.env.NODE_ENV === 'development') {
      const coords = { lat: 51.5074, long: -0.1278 };
      setLocation(coords);
      return Promise.resolve(coords);
    }
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const coords = { lat: position.coords.latitude, long: position.coords.longitude };
            setLocation(coords);
            resolve(coords);
          },
          (error) => {
            console.log(error);
            alert("Location access was denied. Please allow location access and try again.");
            setScreen("error");
            reject(error);
          }
        );
      } else {
        alert("Geolocation is not supported by this browser.");
        reject(new Error("Geolocation not supported"));
      }
    });
  };

  useEffect(() => {
    console.log("Fetching Charcode")
    console.log(props)
    const fetchCharcode = async () => {
      try{
        console.log("HELLO")
        let resolvedLocation = await getLocation();

        if(!resolvedLocation || typeof resolvedLocation.lat !== "number"){
          console.log("Exited fetchCharcodes because location wasn't defined")
          return;
        }

        const request = {
          method: "get",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"   
          }
        };
        console.log(props.backEndURL)        
        console.log(charcodeId)

        let response = await fetch(props.backEndURL + "/charcode/" + charcodeId + "/" ); // , request
        console.log(response);

        // console.log(props.backEndURL + "/charcode/" + charcodeId)
        let jsonResponse = await response.json(); 
        console.log(jsonResponse);
        if (jsonResponse.success) {
        
          console.log("A")
          console.log(jsonResponse.data.bag);
          setMainBag(jsonResponse.data.bag); 
          setEbcBatchUrl(jsonResponse.data.ebcBatchLink || "");
          setShowEbcCert(jsonResponse.data.showEbcCert || false);

          console.log("A2")
          console.log(jsonResponse.data.bag.status)
       

          if(jsonResponse.data.bag.status === "assigned" && jsonResponse.data.bag._order && Array.isArray(jsonResponse.data.bag._order.products)){
            console.log("A3")

            setTotalBagsExpected(jsonResponse.data.bag._order.products[0].amount + jsonResponse.data.bag._order.products[1].amount)    
          }
          console.log("A4")

          console.log(jsonResponse.data.bag)
          //        
          console.log("b")
          console.log(jsonResponse.data)
          // if(jsonResponse.data.bag.status !== "unassigned"){
          //   setOrderNumberBags(jsonResponse.data.orders[0].products[0].amount);
          // }
          console.log("C")
          let bagScreen;
          setIsStorage(false);
          setIsProcessing(false);
          switch(jsonResponse.data.bag.status){
            case "unassigned":
              bagScreen = "bagging";
              break;
            case "delivered_to_storage":
            case "delivered_to_processing":
            case "bagged" :
              bagScreen = jsonResponse.data.orders === "n/a" ?  "noOrders" : "pickup";
              console.log(jsonResponse.data.orders)
              console.log(jsonResponse.data);
              setOrders(jsonResponse.data.orders);
              setOrdersContent(jsonResponse.data.ordersContent)
              break;
            case "assigned":
              setOrders(jsonResponse.data.orders);
              setOrdersContent(jsonResponse.data.ordersContent);
              setScanResults([]);
              if (jsonResponse.data.bag._order?._id) {
                const bagOrder = jsonResponse.data.bag._order;
                const assignedOrderId = String(bagOrder._id);
                setSelectedOrder(assignedOrderId);
                setLastAddedCharcode(charcodeId);
                setLastAddedOrderDisplayId(bagOrder.order_id || assignedOrderId);
                if (Array.isArray(bagOrder.products)) {
                  const expected = bagOrder.products[0].amount + bagOrder.products[1].amount;
                  const assignedCount = (jsonResponse.data.ordersContent || []).filter(
                    item => String(item.order_id) === assignedOrderId
                  ).length;
                  setSuccessScreen(assignedCount >= expected ? "fullyLoaded" : "bagAdded");
                } else {
                  setSuccessScreen("bagAdded");
                }
              } else {
                setSuccessScreen("bagAdded");
              }
              bagScreen = "success";
              break;
            // case "bagged" :
            //     bagScreen = "pickup";
            //     console.log("BAGGEDg")
            //     console.log(jsonResponse.data);
            //     setOrders(jsonResponse.data.orders);
            //     setOrdersContent(jsonResponse.data.ordersContent)
            //     break;
            // // case "assigned": REMOVED ASSIGN 
            // //   bagScreen = "pickup";
            // //   console.log(jsonResponse.data);
            // //   setOrders(jsonResponse.data.orders);
            // //   break;
            case "pickedUp":
              bagScreen = "delivery";
              console.log(jsonResponse.data)
              setOrders(jsonResponse.data.orders);
              setFarmer(jsonResponse.data.user) //TODO 
              setScanResults(jsonResponse.data.bagsFromOrder.map((bagFromOrder) => {
                  return {charcode: bagFromOrder.charcode, checked: bagFromOrder.charcode === charcodeId ? true : false};
              }))
       
              setBagsFromOrder(jsonResponse.data.bagsFromOrder);
              const pickupComplete = Boolean(jsonResponse.data.bag?.locations?.pickup?.time);
              const processingOrder = jsonResponse.data.bag?.locations?.processing_pickup?._order_to_processing;
              const processingDeliveryComplete = Boolean(jsonResponse.data.bag?.locations?.processing_delivery?.time);
              const storageOrder = jsonResponse.data.bag?.locations?.storage_pickup?._order_to_storage;
              const storageDeliveryComplete = Boolean(jsonResponse.data.bag?.locations?.storage_delivery?.time);

              if (!pickupComplete && processingOrder && !processingDeliveryComplete && Array.isArray(processingOrder.products)) {
                const pin = processingOrder.products[0]?.amount || 0;
                const pel = processingOrder.products[1]?.amount || 0;
                setTotalBagsExpected(pin + pel);
                setIsProcessing(true);
                setIsStorage(false);
              } else if (!pickupComplete && storageOrder && !storageDeliveryComplete && Array.isArray(storageOrder.products)) {
                const pin = storageOrder.products[0]?.amount || 0;
                const pel = storageOrder.products[1]?.amount || 0;
                setTotalBagsExpected(pin + pel);
                setIsStorage(true);
                setIsProcessing(false);
              } else if (Array.isArray(jsonResponse.data.bag?._order?.products)) {
                const pin = jsonResponse.data.bag._order.products[0]?.amount || 0;
                const pel = jsonResponse.data.bag._order.products[1]?.amount || 0;
                setTotalBagsExpected(pin + pel);
                setIsStorage(false);
                setIsProcessing(false);
              } else {
                setTotalBagsExpected("?");
                setIsStorage(false);
                setIsProcessing(false);
              }

              break;
            case "delivered": 

              setBagsFromOrder(jsonResponse.data.bagsFromOrder);
              console.log(jsonResponse.data.zones)
              console.log("hhhhhhhhhhhhhhhh")
              setZones(jsonResponse.data.zones);
              bagScreen = "application";
              break; 
            case "applied":
              bagScreen = "alreadyApplied";
              break;
            case "delivered_storage":
            case "delivered_processing":
              bagScreen = "pickup";
              console.log("BAGGEDg")
              console.log(jsonResponse.data);
              setOrders(jsonResponse.data.orders);
              setOrdersContent(jsonResponse.data.ordersContent)
              break;
          // case "assigned": REMOVED ASSIGN 
          //   bagScreen = "pickup";
          //   console.log(jsonResponse.data);
          //   setOrders(jsonResponse.data.orders);
          //   break;
          }
          console.log(bagScreen)
          setScreen(bagScreen)

          console.log(jsonResponse.data);
          // setOrders(newOrders);
          console.log("SILENTLY COMPLETES ITS MISSION, LIKE  A NINJA");
        } else {
          // alert("Error: " + jsonResponse.message);
          setScreen("404")
          console.log("Fetch Bag Failed...")
        }
      }catch(err){
        // alert("OUPSSS");
        return;
      }
      
      
    }
    fetchCharcode();
  },[props.backEndURL, retry, location])

  

  const removeCharcode = (charcode) => {
    console.log(scanResults);
    setScanResults(prevScanResults => prevScanResults.filter(element => element !== charcode));
  }

  const addCharcode = (charcode) => {
    // alert("CHARCODS")
    // console.log(charcode);
    // console.log(scanResults);
    let copy = scanResults.map((x) => x);
    // console.log(copy);
    if(typeof charcode === "string"){
      copy.push({charcode: charcode, checked: true})
      let result = "";
        if(!scanResults.includes(charcode)){
          result = copy;
          setScanResults(result);
        } else {
          console.log("YAI")
          setScanResults(scanResults)
        }


    }else{
      copy.push(charcode)
      let result = "";
        if(!scanResults.includes(charcode)){
        result = copy;
        setScanResults(result);
        } else {
        console.log("YAI")
        setScanResults(scanResults)
        }
    }
  
    

  }

  const renderOrdersData = (ord) => {
    console.log(ord)
    console.log(orders) // [0]
    let data = ord.map((order) => {
      if (order.destination_type === "site") {
        const destinationCategory = order?._destination_site?.category?.toLowerCase() || "";
        const isProcessingSite = destinationCategory === "processing";
        const siteIcon = isProcessingSite ? iconIndustry : iconStorage;
        const siteName = order?._destination_site?.name || "Site";
        const badgeLabel = isProcessingSite ? "Processing" : "Storage";
        return ({
          name: <div className={styles.orderId}>
            {order.order_id} | &nbsp; <img src={siteIcon} className={styles.storageSelector}/> <span style={{fontWeight: "bold", fontSize: "14px"}}>{siteName}</span>&nbsp;<span style={{fontSize: "12px"}}>({badgeLabel})</span></div> ,
          value: order._id
        })
      }
        return ({
          name: <div className={styles.orderId}>
            {order.order_id} | &nbsp;<span style={{fontWeight: "bold", fontSize: "14px"}}>{order._user.first_name}</span></div> ,
          value: order._id
        })
    })
    return(data);
  }

  

  const updateScannedCharcodes = (charcode, isBeingAdded) => {
    if(isBeingAdded){
      console.log("a")
      console.log(charcode);
      // console.log(scanResults);
      setScanResults(prevScanResults => [...prevScanResults, charcode])
    } else {
      const updatedItems = scanResults.filter((_, index) => index !== scanResults.indexOf(charcode));
      setScanResults(updatedItems)
    }
  }

  const collapseCharcodes = () => {
    setCharcodesCollapsed(!charcodesCollapsed)
  }

  const updateBagsStatus = async (forceOverrideSite = false) => {


    //LOGIC HERE 

    let bags = [];
    let requestBody;

    ///BAGGING
    switch(screen){
      case "bagging": {
        console.log("AAAAAAA1")

        // Collect all validation issues up front so they can be shown one after another
        const baggingIssues = [];

        if (moistureContent !== "") {
          if (!isValidNumberFormat(moistureContent)) {
            baggingIssues.push({ type: "hard", title: "Invalid moisture content", body: `"${moistureContent}" is not a valid number. Please enter a number (e.g. 26.8).`, details: [] });
          } else {
            const mcNum = parseFloat(moistureContent);
            if (mcNum < 20 || mcNum > 30) {
              baggingIssues.push({ type: "soft", title: "Moisture content warning", body: `${mcNum}% is outside the acceptable range (20–30%). Do you want to proceed?`, details: [] });
            }
          }
        }

        if (internalTemperature !== "") {
          if (!isValidNumberFormat(internalTemperature)) {
            baggingIssues.push({ type: "hard", title: "Invalid temperature", body: `"${internalTemperature}" is not a valid number. Please enter a number (e.g. 38.5).`, details: [] });
          } else {
            const tempNum = parseFloat(internalTemperature);
            if (tempNum > 45) {
              baggingIssues.push({ type: "hard", title: "Bag too hot!", body: `Bag temperature is ${tempNum}°C — danger of bag melt. Do not proceed.`, details: ["Call 07510 832911 immediately."] });
            }
          }
        }

        if (site === "JNR") {
          const jnrWeight = parseFloat(weight);
          if (!isNaN(jnrWeight) && (jnrWeight < 225 || jnrWeight > 325)) {
            baggingIssues.push({ type: "soft", title: "Weight warning", body: `${jnrWeight}kg is outside the normal range for Jenkinson site (225–325kg). Do you want to proceed?`, details: [] });
          }
        }

        // Show all hard errors one by one (OK only), then stop so the user can fix them
        const hardIssues = baggingIssues.filter(i => i.type === "hard");
        for (const issue of hardIssues) {
          await awaitPopup(issue);
        }
        if (hardIssues.length > 0) return;

        // Show soft warnings one by one (Proceed / Cancel) — stop if user cancels any
        for (const issue of baggingIssues.filter(i => i.type === "soft")) {
          const proceed = await awaitPopup(issue);
          if (!proceed) return;
        }

        for (const scanResult of scanResults ) {
          console.log(scanResult)
          let bag = {
            charcode: scanResult,
            baggingDate: baggingDate,
            weight: weight,
            site: site,
            moistureContent: moistureContent,
            internalTemperature: internalTemperature
          };
          console.log(bag)
          bags.push(bag);
        }
        console.log("AAAAAAA2")

        requestBody = {
          bagsToUpdate: bags,
          newStatus: "bagged",
          location: location
        };
        console.log("CCCCbaggingCCC");
        console.log(requestBody);
        break;
      }


//ASSIGNMENT
      case "assign":
        scanResults.forEach((charcode) => {
          let bag = {
            charcode: typeof charcode === "string" ? charcode : charcode.charcode,
            site: site
          };
          bags.push(bag);
        })
        requestBody = {
          bagsToUpdate: bags,
          selectedOrder: selectedOrder,
          newStatus: "assigned",
          location: location  
        }
        console.log("DDDassigningDDD");
        console.log(requestBody);
        break; 


        //PICKUP
      case "pickup":
        console.log(selectedOrder)
        let filteredOrders = orders.filter(order => order._id === selectedOrder);
        let deliverToStorage = false;
        let deliverToProcessing = false;
        if (filteredOrders[0] && filteredOrders[0].destination_type === "site"){
          const destinationCategory = filteredOrders[0]?._destination_site?.category?.toLowerCase() || "";
          if (destinationCategory === "processing"){
            deliverToProcessing = true;
          } else {
            deliverToStorage = true;
          }
        } 
        scanResults.forEach((charcode) => {
          let bag = {
            charcode: typeof charcode === "string" ? charcode : charcode.charcode
          };
          bags.push(bag);
        })
        
        
        requestBody = {
          bagsToUpdate: bags,
          newStatus: "assigned",
          selectedOrder: selectedOrder,
          deliverToStorage: deliverToStorage,
          deliverToProcessing: deliverToProcessing,
          location: location,
          overrideSiteCheck: forceOverrideSite
        }
        // Capture info for the success screen
        const addedCharcodeText = bags.map(b => b.charcode).join(", ");
        setLastAddedCharcode(addedCharcodeText);
        const addedOrder = orders.find(o => String(o._id) === String(selectedOrder));
        setLastAddedOrderDisplayId(addedOrder?.order_id || "the order");
        setSuccessScreen(checkIfOrderFull() ? "fullyLoaded" : "bagAdded")
        break;

      //DELIVERY

      case "delivery":
        scanResults.forEach((charcode) => {
          let bag = {
            charcode: typeof charcode === "string" ? charcode : charcode.charcode
          };
          bags.push(bag);
        })
        if(sigCanvas.current.isEmpty()) {
          alert("Please provide a signature first.");
          return;
        }
        
        const signatureDataURL = sigCanvas.current.toDataURL();

        requestBody = {
          bagsToUpdate: bags,
          newStatus: "delivered",
          selectedOrder: selectedOrder,
          location: location,
          signatureUrl: signatureDataURL,
          deliverToStorage: isStorage,
          deliverToProcessing: isProcessing
        };
   


        break;
       //DELIVERY

      case "application":
       scanResults.forEach((charcode) => {
        let bag = {
          charcode: typeof charcode === "string" ? charcode : charcode.charcode,
          appliedTo: endUse,
          applicationDate: applicationDate,
        };
        bags.push(bag);
      })
      requestBody = {
        bagsToUpdate: bags,
        newStatus: "applied",
        selectedOrder: selectedOrder,
        location: location,
        selectedZone: zoneId
      };
      break;
      case "application":
       return;
      
    }

    console.log(requestBody);
    const request =  {
      method: "put",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(requestBody)
    };
    console.log(request)
    console.log(user.backEndURL);
    console.log("MADE A REQUEST")
    let response = await fetch(user.backEndURL + "/charcodes", request);
    let jsonResponse = await response.json();
    if (jsonResponse.success) {
      console.log("SUCCEEDED A REQUEST")
      console.log(jsonResponse);
      if (screen === "pickup" && selectedOrder) {
        const committedBags = bags.map((bag) => ({
          order_id: selectedOrder,
          charcode: bag.charcode,
        }));
        const existing = new Set(
          ordersContent.map((item) => `${String(item.order_id)}:${item.charcode}`)
        );
        const updatedOrdersContent = [
          ...ordersContent,
          ...committedBags.filter(
            (item) => !existing.has(`${String(item.order_id)}:${item.charcode}`)
          ),
        ];
        setOrdersContent(updatedOrdersContent);
        setScanResults([]);
        const addedOrder = orders.find(o => String(o._id) === String(selectedOrder));
        const orderDisplayId = addedOrder?.order_id || selectedOrder;
        navigate(`/scan/${orderDisplayId}`, {
          state: { selectedOrder, orders, ordersContent: updatedOrdersContent, totalBagsExpected, location, charcodeId }
        });
        return true;
      }
      setScreen("success");
      console.log("SILENTLY COMPLETES ITS MISSION, LIKE A NINJA");
      return true;
    } else {
      const errorType = jsonResponse?.errorType;

      if (errorType === "WRONG_SITE") {
        setErrorPopup({
          title: "Location mismatch",
          body: `Bag ${jsonResponse.charcode} is at ${jsonResponse.bagSiteName}, but this order picks up from ${jsonResponse.expectedSiteName}. Would you like to add the bag anyway?`,
          details: [],
          onConfirm: () => updateBagsStatus(true),
        });
      } else if (errorType === "NOT_EBC_CERTIFIED") {
        setErrorPopup({
          title: "Bag not EBC certified",
          body: `Bag ${jsonResponse.charcode} is not EBC certified and cannot be added to this order. Remove EBC certification from the label if not already done.`,
          details: [],
        });
      } else if (errorType === "TOO_RECENT") {
        const parsedDate = jsonResponse.baggingDate ? new Date(jsonResponse.baggingDate) : null;
        const dateStr = parsedDate && !Number.isNaN(parsedDate.getTime())
          ? parsedDate.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" })
          : "Unknown date";
        setErrorPopup({
          title: "Bag produced less than 5 days ago",
          body: `Bag ${jsonResponse.charcode} was bagged on ${dateStr} and must wait 5 days before it can be picked up.`,
          details: ["Remove this bag from the list."],
        });
      } else {
        setErrorPopup({
          title: "Pickup failed",
          body: jsonResponse.message ?? "An unexpected error occurred.",
          details: [],
        });
      }
      console.log(jsonResponse)
      console.log("FAILLED A REQUEST")
      console.log("Fetch Subscription Failed...")
      return false;
    }
  }








  const openFinaliseShipment = () => {
    const order = orders.find(o => String(o._id) === String(selectedOrder));
    const alreadyLoaded = ordersContent.filter(o => String(o.order_id) === String(order?.order_id)).length;
    const sessionBags = scanResults.length + alreadyLoaded;
    navigate(`/order/${order.order_id}`, { state: { sessionBags } });
  };








  
  
  const addBagToOrderFromScanner = async (charcode, overrideSiteCheck = false) => {
    const currentOrder = orders.find(o => String(o._id) === String(selectedOrder));
    let deliverToStorage = false;
    let deliverToProcessing = false;
    if (currentOrder && currentOrder.destination_type === "site") {
      const destCat = currentOrder._destination_site?.category?.toLowerCase() || "";
      if (destCat === "processing") deliverToProcessing = true;
      else deliverToStorage = true;
    }
    const requestBody = {
      bagsToUpdate: [{ charcode }],
      newStatus: "assigned",
      selectedOrder,
      deliverToStorage,
      deliverToProcessing,
      location,
      overrideSiteCheck
    };

    try {
      const response = await fetch(user.backEndURL + "/charcodes", {
        method: "put",
        headers: { Accept: "application/json", "Content-Type": "application/json" },
        body: JSON.stringify(requestBody)
      });
      const json = await response.json();

      if (json.success) {
        setOrdersContent(prev => [...prev, { order_id: selectedOrder, charcode }]);
      } else {
        const errorType = json.errorType;

        if (errorType === "WRONG_SITE") {
          setErrorPopup({
            title: "Location mismatch",
            body: `Bag ${json.charcode} is at ${json.bagSiteName}, but this order picks up from ${json.expectedSiteName}. Would you like to add the bag anyway?`,
            details: [],
            onConfirm: () => addBagToOrderFromScanner(charcode, true),
          });
        } else if (errorType === "NOT_EBC_CERTIFIED") {
          setErrorPopup({
            title: "Bag not EBC certified",
            body: `Bag ${json.charcode} is not EBC certified and cannot be added to this order. Remove EBC certification from the label if not already done.`,
            details: [],
          });
        } else if (errorType === "TOO_RECENT") {
          const parsedDate = json.baggingDate ? new Date(json.baggingDate) : null;
          const dateStr = parsedDate && !Number.isNaN(parsedDate.getTime())
            ? parsedDate.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" })
            : "Unknown date";
          setErrorPopup({
            title: "Bag produced less than 5 days ago",
            body: `Bag ${json.charcode} was bagged on ${dateStr} and must wait 5 days before it can be picked up.`,
            details: ["Remove this bag from the list."],
          });
        } else {
          setErrorPopup({
            title: "Failed to add bag",
            body: json.message ?? "An unexpected error occurred.",
            details: [],
          });
        }
      }
    } catch (err) {
      console.error("addBagToOrderFromScanner error:", err);
      setErrorPopup({
        title: "Network error",
        body: "Could not connect to server.",
        details: [],
      });
    }
  };

  const renderContent = () => {
    switch(screen){
      case "loading": return (
        <div className={styles.coolFont}> 
          Charcode Loading...
        </div>
      ); 
      case "404": return (
        <> 
        <img src={icon404} className={styles.mainIllustration}/>
        <div className={styles.header}>
          Bag not found..
        </div>
        <div className={styles.description}>
            Server was unable to find Charcode #{charcodeId}. Check that the Charcode ID is correct.
        </div>
        <div className={styles.sectionHeader} onClick={() => collapseCharcodes()}>
            <div>
              <span className={styles.headerIcon}>shopping-bag</span> Bags ({scanResults.length})
            </div>
            <div className={styles.collapseIcon} >
              {charcodesCollapsed ? "chevron-down" : "chevron-up"}
            </div>
          </div>
          <div className={helpers.clx(styles.charcodesContainer, charcodesCollapsed ? styles.charcodesCollapsed : "")}>
          {scanResults.map((scan) => {
              return(
                <div className={styles.headerCharcode}>
                  {scan}
                </div>
              )            
            })}
        </div>
      </>
      ); 
      case "noOrders": return (
        <> 
        <img src={icon404} className={styles.mainIllustration}/>
        <div className={styles.header}>
          No orders scheduled for today..
        </div>
        <div className={styles.description}>
            Server was unable to find any orders. Check with the BBB team for more details.
        </div>
        <div className={styles.sectionHeader} onClick={() => collapseCharcodes()}>
            <div>
              <span className={styles.headerIcon}>shopping-bag</span> Bags ({scanResults.length})
            </div>
            <div className={styles.collapseIcon} >
              {charcodesCollapsed ? "chevron-down" : "chevron-up"}
            </div>
          </div>
          <div className={helpers.clx(styles.charcodesContainer, charcodesCollapsed ? styles.charcodesCollapsed : "")}>
          {scanResults.map((scan) => {
              return(
                <div className={styles.headerCharcode}>
                  {scan}
                </div>
              )            
            })}
        </div>
      </>
      ); 
      
      case "alreadyApplied": 
        const d = new Date(mainBag.application_date);
        const day = String(d.getDate()).padStart(2, '0'); // Get the day and add leading zero if needed
        const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so add 1
        const year = d.getFullYear(); // Get the full year
        const formattedDate = `${day}/${month}/${year}`;
        return (
          <> 
            <img src={successImage} className={styles.mainIllustration}/>
            <div className={styles.header}>
                Bag Already Applied!
            </div>
            <div className={styles.alreadyAppliedText}>
            <span className={styles.alreadyAppliedTextBold}>{mainBag.charcode}</span>&nbsp;| Applied to: <span className={styles.alreadyAppliedTextBold}>&nbsp;{mainBag.applied_to}&nbsp;</span>  | Applied on: <span className={styles.alreadyAppliedTextBold}>&nbsp;{formattedDate}&nbsp;</span>
            </div>
            <div className={styles.description}>
              For more info regarding the biochar you've already applied, login to the desktop BBB Dashboard.
            </div>
          </>
        );
      case "error": {
        let device;
          const userAgent = navigator.userAgent.toLowerCase();
          if (/android/i.test(userAgent)) {
           device = 'android';
          } else if (/iphone|ipad|ipod/i.test(userAgent)) {
           device = 'ios';
          } else {
            device = 'other';
          }
        
         if (device === 'android') {
          return (
            <>
              <div className={styles.header}>
                Locations Services required
              </div>
              <div className={helpers.clx(styles.description, styles.locationHeadedr)}>
                How to enable location services on Chrome
              </div>
              <ol className={styles.chromeLocationContainer}>
                <img src={chromeLocation1} className={styles.chromeLocation}/>
                <li className={styles.chromeText}>Open the <strong>Settings</strong> on Chrome's URL bar.</li>
                <img src={chromeLocation2} className={styles.chromeLocation}/>

                <li className={styles.chromeText}>Tap on <strong>Permissions</strong>.</li>
                <img src={chromeLocation3} className={styles.chromeLocation}/>
                <li className={styles.chromeText}>Toggle <strong>Location</strong> ON and refresh the page.</li>
              </ol>
              <div className={helpers.clx(styles.description, styles.locationHeadedr)}>
                How to enable location services on Android
              </div>
              <ol className={styles.androidLocationContainer}>
                <li>Open the <strong>Settings</strong> app on your Android device.</li>
                <li>Scroll down and tap on <strong>Location</strong>.</li>
                <li>Toggle <strong>Location</strong> ON.</li>
                <li>Tap on <strong>App Permissions</strong> or <strong>Location Access for Apps</strong>.</li>
                <li>
                  Find your browser (e.g., <strong>Chrome</strong>) or the app requesting location services and ensure <strong>Allow</strong> or <strong>Allow while using the app</strong> is selected.
                </li>
              </ol>
              <Button name={"Retry"} onPress={() => setRetry(!retry)}/>
            </>
          );
        } else if (device === 'ios') {
          return (
            <>
              <div className={styles.header}>
                Locations Services required
              </div>
              <div className={styles.description}>
               How to Enable Location Services on iOS (iPhone/iPad)
              </div>
              <ol>
                <li>Open the <strong>Settings</strong> app on your iPhone or iPad.</li>
                <li>Scroll down and tap on <strong>Privacy</strong>.</li>
                <li>Tap on <strong>Location Services</strong> at the top.</li>
                <li>Ensure <strong>Location Services</strong> is toggled ON.</li>
                <li>Scroll down to find your browser (e.g., <strong>Safari</strong>, <strong>Chrome</strong>).</li>
                <li>
                  Tap on the browser name and select <strong>While Using the App</strong> or <strong>Always</strong> to grant location access.
                </li>
              </ol>
              <Button name={"Retry"} onPress={() => setRetry(!retry)}/>
            </>
          );
        } else {
          return <div className={styles.header}>Instructions are not available for your device.</div>;
        }
    
    }
      case "bagging": return (
        <>  <div className={helpers.clx(styles.charcodesContainer, styles.charcodesContainerBagging)}>
              {scanResults.map((scan) => {
                return(
                  <div className={styles.headerCharcode}>
                    {scan}
                  </div>
                )            
              })}
          
          </div>
            <div className={styles.header}>
              Add New Biochar Bag
            </div>
            <div className={styles.description}>
              Select bagging site, bag weight, and bagging date. You may process multiple bags in one go by clicking the "+ Add/Remove Bags" button
            </div>
            <div className={styles.sectionHeader}>
              <div className={styles.sectionHeaderMain}>
                <img src={iconIndustry} className={styles.fontAwesomeSubstitute}/>  <span className={styles.sectionHeaderText}>Site</span>
              </div>
            </div>
            <div className={styles.inputRow}>
              <Selector name={"Site Name"} labelStyle={"none"} placeholder={"Select site"} value={site} onChange={setSite} data={[{name: "Ahlstrom", value: "ARA"}, {name: "Jenkinson", value: "JNR"}]}/>
            </div>
            <div className={styles.sectionHeader} onClick={() => collapseCharcodes()}>
             
              <div className={styles.moistureContainer} >
                <div className={helpers.clx(styles.sectionHeader, styles.moistureInput)}>
                  <TextInput disabled={false} name={"Moist. Content (%)"} labelStyle={"top"} iconCustom={iconWater} placeholder={"MC"} value={moistureContent} onChange={handleSetMoistureContent}/>
                </div>
                <div className={helpers.clx(styles.sectionHeader, styles.moistureInput)}>
                  <TextInput disabled={false} name={"Bag Temp. (°C)"} labelStyle={"top"} iconCustom={iconHeat} placeholder={"Temp"} value={internalTemperature} onChange={handleSetInternalTemperature}/>
                </div>
              </div>
            </div>
           

          
            <div className={styles.inputRow}>
               <div className={helpers.clx(styles.sectionHeader, styles.weightContainer)}>
                 <TextInput disabled={false} name={"Weight (kg)"} labelStyle={"top"} iconCustom={iconBalanceScale} value={weight} onChange={handleSetWeight}/>
               </div>
               <div className={helpers.clx(styles.sectionHeader)}>
                 <DateSelector name={"Bagging Date"} labelStyle={"top"} iconCustom={iconCalendarAlt} value={baggingDate} onChange={setBaggingDate}/>
               </div>
            </div>
            <div className={styles.ghostSpace}/>
            <Button disabled={site === "" ? true: false} name="Confirm Bagging" onPress={updateBagsStatus} color={"Grass"}/>
            <div className={styles.line}/>
            
        </>
      )
      case "assign": return (
       
        <> 
            <div className={helpers.clx(styles.header, styles.smallerHeader)}>
             Assign Bags
            </div>
            <div className={styles.description}>
              Assign bags to an order. You may process multiple bags in one go by clicking the "+ Add/Remove Bags" button
            </div>
            <div className={styles.sectionHeader} onClick={() => collapseCharcodes()}>
              <div>
                <img src={iconShoppingBag} className={styles.fontAwesomeSubstitute}/>  Bags {"(" + scanResults.length + " / " + totalBagsExpected + ")"}
              </div>
              <div className={styles.collapseIcon} onClick={() => collapseCharcodes()}>
                {charcodesCollapsed ? "chevron-down" : "chevron-up"}
              </div>
            </div>
            <div className={helpers.clx(styles.charcodesContainer, charcodesCollapsed ? styles.charcodesCollapsed : "")}>
              {scanResults.map((scan) => {
                  return(
                    <div className={styles.headerCharcode}>
                      {scan}
                    </div>
                  )            
                })}
              <div className={styles.headerCharcode} onClick={() => setDisplayScanner(true)}>
                + Add/Remove Bags
              </div>
            </div>
            { displayScanner ? 
              <QRScanner scanResults={[...scanResults]} removeCharcode={removeCharcode} addCharcode={addCharcode} updateScannedCharcodes={(charcode, isBeingAdded) => updateScannedCharcodes(charcode, isBeingAdded)} closeScanner={() => setDisplayScanner(false)} totalBagsExpected={totalBagsExpected} backEndURL={user.backEndURL}/>
              : null
            }
            <div className={helpers.clx(styles.inputRow, styles.orderSelector)}>
             <Selector name={"Order ID"} labelStyle={"top"} iconName={"FaTruckMoving"} value={selectedOrder} onChange={selectOrder} data={renderOrdersData(orders.filter(order => order.status === "upcoming"))} placeholder={"Select Order"} />    
            </div>
            <Button color={"Grass"} disabled={(selectedOrder === "" && scanResults.length !== totalBagsExpected )? true : false} name="Assign To Order" onPress={updateBagsStatus}/>
            <div className={styles.line}/>
            {ebcBatchUrl && ebcBatchUrl !== "" && showEbcCert ?
               <div className={styles.productInformation} onClick={() => {
                 window.open(ebcBatchUrl, '_blank')?.focus();
               }}>
                <img src={ebc} className={styles.ebcLogo}/>
                  EBC Information
                <span className={styles.productFontAwesome}>
                  chevron-right
                </span>
              </div>
            :
                  ""
            }
         
        </>
      )
      case "pickup": return (
        <>
            <div className={styles.header}>Add Bag to Order</div>
            <div className={styles.description}>
              Select the order to add this bag to, then press Add Bag.
            </div>
            <div className={styles.charcodesContainer}>
              {scanResults.map((scan, i) => (
                <div key={i} className={styles.headerCharcode}>
                  {typeof scan === "string" ? scan : scan.charcode}
                </div>
              ))}
            </div>
            <div className={helpers.clx(styles.inputRow, styles.orderSelector)}>
              <Selector name={"Order ID"} labelStyle={"top"} iconName={"FaTruckMoving"} value={selectedOrder} onChange={selectOrder} data={renderOrdersData(orders.filter(order => order.status === "upcoming" && new Date(order.delivery_date) >= new Date(new Date().toDateString())))} placeholder={"Select Order"} />
            </div>
            <Button color={"Grass"} disabled={!selectedOrder} name="Add More Bags" onPress={() => updateBagsStatus()}/>
            <div className={styles.line}/>
            {ebcBatchUrl && ebcBatchUrl !== "" && showEbcCert ?
              <div className={styles.productInformation} onClick={() => {
                window.open(ebcBatchUrl, '_blank')?.focus();
              }}>
                <img src={ebc} className={styles.ebcLogo}/>
                EBC Information
                <span className={styles.productFontAwesome}>
                  chevron-right
                </span>
              </div>
            :
                  ""
            }
        </>
      )
      case "delivery":

      console.log("DELIVERY")
       console.log(props);
       
       return (
        <> 

          {/* SIGNATURE OVERLAY HERE */}
          <div className={helpers.clx(styles.signatureOverlay, displaySignatureOverlay ? "": styles.signatureOverlayHidden)}>
            
            <div className={helpers.clx(styles.header, styles.smallerHeader)}>
              Finalise Biochar Delivery
            </div>
            <div className={styles.description}>
              Please sign and accept BBB's terms and conditions to finalise your biochar order.
            </div>
            <div className={helpers.clx(styles.sectionHeader, styles.sectionSignature)}>
              <div>
                <span className={styles.headerIcon}>signature</span> Customer Signature
              </div>
            </div>
            <div className={styles.signatureContainer}>
              <SignatureCanvas penColor='black' canvasProps={{/*width: 500, height: 200,*/ className: styles.signature}} ref={sigCanvas}/>
              <div className={styles.resetSignature} onClick={() => clearCanvas()}>trash-restore-alt</div>
            </div>
            <Checkbox 
              thinnerText={false}
              text={"I have checked the contents of my order and confirm they are correct."} 
              checked={acceptedTC} 
              onPress={() => setAcceptedTC(!acceptedTC)}
              />
              <div className={styles.backButtonContainer}>
                <Button disabled={scanResults.length === 0 ? true : false} name="Back" onPress={() => setDisplaySignatureOverlay(false)} color={"Coal"}/>
              </div>
            <Button disabled={scanResults.length === 0 || !acceptedTC ? true : false} name="Complete Order" onPress={updateBagsStatus} color={"Leaf"}/>

          </div>
          <div className={helpers.clx(styles.header, styles.smallerHeader)}>
             Confirm Biochar Delivery
           </div>
            <div className={styles.description}>
              Please check and confirm delivery inventory. You may check each item by scanning QRs, or by clicking on each bag in the list below. For more info on how to use charcodes, please refer to the <span className={styles.descriptionLink} onClick={() => window.open("https://cdn.prod.website-files.com/612de9d6e2e1a211ef704a8c/688fe7c0c13160717182b24e_Charcodes%20Guide%20-%2031-07-25.pdf", "_blank")}>Charcodes Guide</span>.
            </div>
            <div className={helpers.clx(styles.sectionHeader, styles.sectionFarmer)}>
              <div>
                  <img src={iconUserCircle} className={styles.fontAwesomeSubstitute}/>  {farmer}
              </div>
              {/* <div className={styles.collapseIcon}>
                {charcodesCollapsed ? "chevron-down" : "chevron-up"}
              </div> */}
            </div>
            <div className={styles.sectionHeader} onClick={() => collapseCharcodes()}>
              <div>
                  <img src={iconShoppingBag} className={styles.fontAwesomeSubstitute}/> Bags {"(" + scanResults.filter(scan => scan.checked).length + " / " + totalBagsExpected + ")"}
              </div>
              <div className={styles.collapseIcon}>
                {charcodesCollapsed ? "chevron-down" : "chevron-up"}
              </div>
            </div>
            <div className={helpers.clx(styles.charcodesContainer, charcodesCollapsed ? styles.charcodesCollapsed : "", displaySignatureOverlay ? styles.hideBags : "")}>
              {scanResults.map((scan) => {
                  return(
                    // <div className={helpers.clx(styles.headerCharcode, charcodesCollapsed ? styles.headerCharcodeCollapsed : "")}>
                    //   {scan}
                    // </div>
                    <div className={helpers.clx(styles.headerCharcodeCheckbox)} onClick={() => setScanResults(prevResults => prevResults.map(item =>
                      item.charcode === scan.charcode 
                        ? { ...item, checked: !item.checked } 
                        : item
                    ))}>
                      {/* {scan} */}
                      <Checkbox 
                        customStyle={{fontSize: "12px", marginRight: "10px", paddingLeft: "7px", letterSpacing: "-0.05rem" }}
                        thinnerText={false}
                        text={"#" + scan.charcode.substring(4,10)} 
                        checked={scan.checked} 
                        onPress={() => console.log("checkbox press")}
                       />
                    </div>
                  )            
                })}
              <div className={helpers.clx(styles.headerCharcode, styles.headerCharcodeAdd)} onClick={() => setDisplayScanner(true)}>
                + Add/Remove Bags
              </div>
            </div>
            { displayScanner ? 
              <QRScanner scanResults={[...scanResults]} removeCharcode={removeCharcode} addCharcode={addCharcode} updateScannedCharcodes={(charcode, isBeingAdded) => {console.log(charcode);updateScannedCharcodes({charcode: charcode, checked: true}, isBeingAdded)}} closeScanner={() => setDisplayScanner(false)} totalBagsExpected={totalBagsExpected} backEndURL={user.backEndURL}/>
              : null
            }
              {/* <div className={styles.inputRow}>
                <Selector name={"Order ID"} labelStyle={"top"} iconName={"FaTruckMoving"} value={selectedOrder} onChange={setSelectedOrder} data={orders.map((order) => ({name: order.order_id + " (" + order._user.business_name + ")", value: order._id}))} placeholder={"Select Order"}/>
              </div> */}
              {
                (isStorage || isProcessing) ?
                  null
                  :
                   <Charpoints numberOfBags={scanResults.filter(scan => scan.checked).length}/>

              }

              {
                false ?
                <>
                  <div className={styles.sectionHeader}>
                    <div>
                      <span className={styles.headerIcon}>signature</span> Customer Signature
                    </div>
                  </div>
                  <div className={styles.signatureContainer}>
                    <SignatureCanvas penColor='black' canvasProps={{/*width: 500, height: 200,*/ className: styles.signature}} ref={sigCanvas}/>
                    <div className={styles.resetSignature} onClick={() => clearCanvas()}>trash-restore-alt</div>
                  </div>
                </>
                :
                null
                
              }
            <Button disabled={scanResults.length === 0 || scanResults.filter(scan => scan.checked).length !== totalBagsExpected ? true : false} name="Confirm Inventory" onPress={() => setDisplaySignatureOverlay(true)} color={"Coal"}/>
            {console.log(mainBag?._order?.products?.[1] === 0 )}

           <div className={styles.line}/>
            {ebcBatchUrl 
              && ebcBatchUrl !== "" 
              && mainBag?.batch_id !== "batchless"  
              && showEbcCert ? (
                <div
                  className={styles.productInformation}
                  onClick={() => {
                    window.open(ebcBatchUrl, "_blank")?.focus();
                  }}
                >
                  <img src={ebc} className={styles.ebcLogo}/>
                  EBC Information
                  <span className={styles.productFontAwesome}>
                    chevron-right
                  </span>
                </div>
            ) : null}

        </>
      )
      case "application": return (
        <> 
          
            <div className={styles.header}>
              Biochar Application
            </div>
            <div className={styles.description}>
              Log details on your biochar application, and earn £10 in Charpoints for every bag you scan. For more information on how to use Charcodes, please refer to the <span className={styles.descriptionLink} onClick={() => window.open("https://cdn.prod.website-files.com/612de9d6e2e1a211ef704a8c/688fe7c0c13160717182b24e_Charcodes%20Guide%20-%2031-07-25.pdf", "_blank")}>Charcodes Guide</span>.
            </div>
            <div className={styles.sectionHeader} onClick={() => collapseCharcodes()}>
              <div>
                <img src={iconShoppingBag} className={styles.fontAwesomeSubstitute}/> Bags ({scanResults.length})
              </div>
              <div className={styles.collapseIcon} onClick={() => collapseCharcodes()}>
                {charcodesCollapsed ? "chevron-down" : "chevron-up"}
              </div>
            </div>
            <div className={helpers.clx(styles.charcodesContainer, charcodesCollapsed ? styles.charcodesCollapsed : "")}>
              {scanResults.map((scan) => {
                // console.log(scan)
                scan = typeof scan === "string" ? scan : scan.charcode;
                  return(
                    <div className={styles.headerCharcode}>
                      {scan}
                    </div>
                  )            
                })}
              <div className={styles.headerCharcode} onClick={() => setDisplayScanner(true)}>
                + Add/Remove Bags
              </div>
            </div>
            { displayScanner ? 
              <QRScanner scanResults={[...scanResults]} removeCharcode={removeCharcode} addCharcode={addCharcode} updateScannedCharcodes={(charcode, isBeingAdded) => updateScannedCharcodes(charcode, isBeingAdded)} closeScanner={() => setDisplayScanner(false)} backEndURL={user.backEndURL}/>
              : null
            }
            {/* <div className={styles.inputRow}>
              <Selector name={"Delivery ID"} labelStyle={"top"} value={selectedDelivery} onChange={setSelectedDelivery} data={deliveries.map((delivery) => ({name: delivery.delivery_id, value: delivery._id}))} placeholder={"Select Delivery"} iconName={"FaTruckMoving"}/>
            </div> */}
            <Charpoints numberOfBags={scanResults.length}/>
            <div className={helpers.clx(styles.inputRow, styles.inputRowSpaceBetween)}>
              <div className={styles.applicationDateContainer}>
                <DateSelector name={"Applied on"} labelStyle={"top"} value={applicationDate} onChange={setApplicationDate}/>
              </div>
              <div className={styles.applicationTypeContainer}>
                  <Selector name={"Applied to"} placeholder={"Select"} labelStyle={"top"} value={endUse} onChange={setEndUse} data={[{name: "Bedding", value: "bedding"}, {name: "Slurry", value: "slurry"}, {name: "FYM", value: "fym"}, {name: "Direct to land", value: "directToLand"},  {name: "Compost", value: "compost"}]}/>
              </div>
            </div>
            <div className={styles.inputRow}>
                            {/* <div className={styles.zoneContainer}>

              <Checkbox 
                thinnerText={false}
                text={"Applied to Zone"}
                checked={appliedToZone}
                onPress={() => setAppliedToZone(!appliedToZone)}
              />
              </div> */}
              <div className={styles.zoneContainer}>
                <Selector name={"Application Zone"} placeholder={"Select Application"} labelStyle={"top"} value={zoneId} onChange={setZoneId} data={zones
                  .sort((a, b) => a.zone_name.localeCompare(b.zone_name))
                  .map(zone => ({
                    name: <div className={styles.zoneOption}>
                      <span className={styles.zoneTypeIcon}>
                        {zone.zone_type === "livestock" ? "home" : "seedling"}
                      </span>
                      {zone.zone_name}
                    </div>,
                    value: zone._id
                  }))}/>

              </div>
            </div>
            <div className={styles.buttonWrapper}>
              <Button color={"Grass"} disabled={false} name="Confirm Application" onPress={updateBagsStatus}/>
            </div>
            <div className={styles.line}/>
            {
                ebcBatchUrl && ebcBatchUrl !== "" && mainBag.batch_id !== "batchless" && showEbcCert ?
                  <div className={styles.productInformation} onClick={() => {
                    window.open(ebcBatchUrl, '_blank')?.focus();
                  }}>
                  <img src={ebc} className={styles.ebcLogo}/>
                  EBC Information
                  <span className={styles.productFontAwesome}>
                    chevron-right
                  </span>
                </div>
            :
                 ""
            }
    
            {/* <div className={styles.charcodesContainer}>
              <div className={styles.headerCharcode}>
                {mainBag.charcode}
              </div>
              <div className={styles.headerCharcode} onClick={() => setDisplayScanner(true)}>
                + Add/Remove Bags
              </div>
            </div>
            { displayScanner ? 
              <QRScanner scanResults={[...scanResults]} removeCharcode={removeCharcode} addCharcode={addCharcode} updateScannedCharcodes={(charcode, isBeingAdded) => updateScannedCharcodes(charcode, isBeingAdded)} closeScanner={() => setDisplayScanner(false)}/>
              : null
            }

            <div className={styles.content}>
              <div className={styles.inputRow}>
                <TextInput name={"Number of bags used"} labelStyle={"top"} value={bagsNumber} onChange={setBagsNumber}/>
                <DateSelector name={"Application date"} labelStyle={"top"} value={applicationDate} onChange={setApplicationDate}/>
              </div>
              <div className={styles.inputRow}>
                <Selector name={"Biochar applied to"} labelStyle={"top"} value={endUse} onChange={setEndUse} data={[{name: "Bedding", value: "bedding"}, {name: "Slurry", value: "slurry"}, {name: "FYM", value: "fym"}, {name: "Direct to land", value: "directToLand"}]}/>
                <TextInput name={"Machinery used"} labelStyle={"top"} value={machinery} onChange={setMachinery}/>
              </div>
              <div className={styles.inputRow}>
                Please press on button to confirm your biochar delivery.
              </div>
            </div>
            <Button name="Confirm Delivery" onPress={updateBagsStatus}/> */}
        </>
      )
      case "success": return (
        <>
          {(successScreen === "bagAdded" || successScreen === "fullyLoaded") ? (
            <>
              <img src={successImage} className={styles.mainIllustration}/>
              <div className={styles.header}>Bag Added!</div>
              <div className={styles.description}>
                {lastAddedCharcode} was added to order {lastAddedOrderDisplayId}.
              </div>
              <div className={styles.ghostSpace}/>
              <Button
                color="Grass"
                name="View Order"
                onPress={() => navigate(`/scan/${lastAddedOrderDisplayId}`, {
                  state: {
                    selectedOrder,
                    orders,
                    totalBagsExpected,
                    location,
                    charcodeId,
                    initialScreen: "orderView",
                  },
                })}
                customStyle={{width:"100%", marginBottom:"8px"}}
              />
              {successScreen === "bagAdded"
                ? <Button color="Grass" name="Add More Bags" onPress={() => navigate(`/scan/${lastAddedOrderDisplayId}`, { state: { selectedOrder, orders, ordersContent, totalBagsExpected, location, charcodeId } })} customStyle={{width:"100%"}}/>
                : <Button color="Grass" name="Finalise Order" onPress={openFinaliseShipment} customStyle={{width:"100%"}}/>
              }
            </>
          ) : (
            <>
              <img src={successImage} className={styles.mainIllustration}/>
              <div className={styles.header}>Bag(s) Successfully Updated!</div>
              <div className={styles.description}>
                The following bags were successfully updated:
              </div>
              <div className={styles.sectionHeader} onClick={() => collapseCharcodes()}>
                <div>
                  <span className={styles.headerIcon}>shopping-bag</span> Bags ({scanResults.length})
                </div>
                <div className={styles.collapseIcon}>
                  {charcodesCollapsed ? "chevron-down" : "chevron-up"}
                </div>
              </div>
              <div className={helpers.clx(styles.charcodesContainer, charcodesCollapsed ? styles.charcodesCollapsed : "")}>
                {scanResults.map((scan, i) => (
                  <div key={i} className={styles.headerCharcode}>
                    {typeof scan === "string" ? scan : scan.charcode}
                  </div>
                ))}
              </div>
            </>
          )}
        </>
      )
      case "orderView": {
        const currentOrder = orders.find(o => String(o._id) === String(selectedOrder));
        const orderDisplayId = currentOrder?.order_id || "Order";
        const existingBags = ordersContent.filter(item => String(item.order_id) === String(selectedOrder));
        const sessionBags = scanResults.map(s => ({ charcode: typeof s === "string" ? s : s.charcode }));
        const allCount = existingBags.length + sessionBags.length;
        const orderFull = allCount >= totalBagsExpected;
        return (
          <>
            <div className={styles.header}>Order {orderDisplayId}</div>
            <div className={styles.description}>Bags loaded for this order</div>
            <div className={styles.sectionHeader}>
              <div>
                <img src={iconShoppingBag} className={styles.fontAwesomeSubstitute}/>
                {" "}Bags ({allCount} / {totalBagsExpected})
              </div>
            </div>
            <div className={styles.charcodesContainer}>
              {existingBags.map((bag, i) => (
                <div key={"ex-" + i} className={styles.headerCharcode}>
                  {bag.charcode}
                </div>
              ))}
              {sessionBags.map((bag, i) => (
                <div key={"ses-" + i} className={styles.headerCharcode}>
                  {bag.charcode}
                </div>
              ))}
            </div>
            <div className={styles.ghostSpace}/>
            {orderFull
              ? <Button color="Grass" name="Finalise Order" onPress={openFinaliseShipment} customStyle={{width:"100%"}}/>
              : <Button color="Grass" name= "Add/Remove bags" onPress={() => navigate(`/scan/${orderDisplayId}`, { state: { selectedOrder, orders, ordersContent, totalBagsExpected, location, charcodeId } })} customStyle={{width:"100%"}}/>
            }
          </>
        );
      }
    }
  }

  return (
    <div className={styles.fullContainer}>
      <div className={styles.patternBg}/>
      <img src={dots} className={styles.pattern1}/>
      <img src={dots} className={styles.pattern2}/>
     
      <div className={styles.blackContainerWrapper}>
        <div className={styles.logoContainer}>
          <img src={bbbLogo} className={styles.logo}/>
        </div>
        <div className={styles.blackContainer}>
        <div className={helpers.clx(styles.container, displayScanner && styles.containerNoPadding)} ref={containerRef}>
          <img src={greenCircles} className={styles.circle1}/>
          <img src={greenCircles} className={styles.circle2}/>
          <img src={dots} className={styles.pattern1}/>
          <img src={dots} className={styles.pattern2}/>
          {renderContent()}

          {/* ── Inline error popup ── */}
          {errorPopup && (
            <div className={styles.errorPopupOverlay}>
              <div className={styles.errorPopupCard}>
                <div className={styles.errorPopupTitle}>{errorPopup.title}</div>
                <div className={styles.errorPopupBody}>{errorPopup.body}</div>
                {errorPopup.details?.length > 0 && (
                  <ul className={styles.errorPopupDetails}>
                    {errorPopup.details.map((d, i) => <li key={i}>{d}</li>)}
                  </ul>
                )}
                {errorPopup.onConfirm ? (
                  <>
                    <Button
                      name={errorPopup.confirmLabel || "Yes, add anyway"}
                      onPress={() => {
                        if (errorPopup.closeOnConfirm !== false) setErrorPopup(null);
                        errorPopup.onConfirm();
                      }}
                      color="Grass"
                      customStyle={{ marginTop: "12px", width: "100%", marginBottom: "6px" }}
                    />
                    <Button
                      name={errorPopup.cancelLabel || "No"}
                      onPress={() => { setErrorPopup(null); errorPopup.onDismiss?.(); }}
                      color="Coal"
                      customStyle={{ width: "100%" }}
                    />
                  </>
                ) : (
                  <Button
                    name="OK"
                    onPress={() => { setErrorPopup(null); errorPopup.onDismiss?.(); }}
                    color="Coal"
                    customStyle={{ marginTop: "12px", width: "100%" }}
                  />
                )}
              </div>
            </div>
          )}
        </div>
        </div>
      </div>
      <div className={styles.websiteLink} onClick={() => window.open("https://blackbullbiochar.com", '_blank').focus()}>
        <span className={styles.fontAwesome}>globe</span> BLACKBULLBIOCHAR.COM
      </div>
   
    </div>
    
  );
}




export default CharcodeScreen;
